export default {
    LANG: 'lang',
    PAGE_TITLE: 'pageTitle',
    TOGGLE_LOGOUT: 'toggleLogout',
    CHANGE_CARD_ID: 'toggleCardId',
};
